module.exports = __webpack_public_path__ + "static/media/assessments.c4e0384c.svg";